import store from '../../../../store';
export default function checkIfCanDestroy() {
  let exists = false;
  let scopes = store.getters.userScopes;
  if (scopes.includes('system_company_destroy')) {
    exists = true;
  }
  return exists;
}
